import * as React from 'react';
import Spinner from 'components/spinner';
import { FriendsReferralApiService } from '@sitegen/common/classes/friends-referral-api';
import { IStatusContainerProps } from './status-check.types';

export class StatusCheck extends React.Component<IStatusContainerProps> {
    public componentDidMount() {
        FriendsReferralApiService.configureAPI({
            env: this.props.env,
            campaignId: this.props.campaignId,
        });

        return this.props.getCampaignStatus();
    }

    public render(): JSX.Element {
        return <Spinner />;
    }
}
